export const countryList = [
  { name: "Azerbaijan", cities: ["Baku", "Ganja", "Sumqayit", "Mingachevir", "Sheki"] },
  { name: "USA", cities: ["New York", "Los Angeles", "Chicago", "Houston", "Miami"] },
  { name: "Turkey", cities: ["Istanbul", "Ankara", "Izmir", "Bursa", "Antalya"] },
  { name: "Russia", cities: ["Moscow", "Saint Petersburg", "Novosibirsk", "Yekaterinburg", "Kazan"] },
  { name: "France", cities: ["Paris", "Marseille", "Lyon", "Toulouse", "Nice"] },
  { name: "Italy", cities: ["Rome", "Milan", "Naples", "Turin", "Florence"] }
];
